import { Params } from '@angular/router';

/** Shared query-param keys for the time-tracking month/year timeframe. */
export const TIMEFRAME_YEAR_PARAM = 'filter[year]';
export const TIMEFRAME_MONTH_PARAM = 'filter[month]';

export interface Timeframe {
  year: string | null | undefined;
  month: string | null | undefined;
}

export function applyTimeframeQueryParams(
  base: Params,
  timeframe: Timeframe,
  includeMonth = true,
): Params {
  const params: Params = { ...base };

  if (timeframe.year) {
    params[TIMEFRAME_YEAR_PARAM] = timeframe.year;
  } else {
    delete params[TIMEFRAME_YEAR_PARAM];
  }

  if (includeMonth && timeframe.month) {
    params[TIMEFRAME_MONTH_PARAM] = timeframe.month;
  } else {
    delete params[TIMEFRAME_MONTH_PARAM];
  }

  return params;
}
